import React from "react";
import IconePix from "./IconePix";
import IconeCartaoCredito from "./IconeCartaoCredito";

const FormaPagamentoIcon = ({ forma, size = 32, className = "" }) => {
  const tipo = forma === "cartao" ? "cartao" : "pix";
  const Icon = tipo === "cartao" ? IconeCartaoCredito : IconePix;

  return (
    <span className={`forma-pagamento-icon forma-pagamento-icon--${tipo} ${className}`.trim()}>
      <Icon size={size} />
    </span>
  );
};

export default FormaPagamentoIcon;
